module.exports = __webpack_public_path__ + "static/media/fe_hero.3ac7441b.jpg";